import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Grid } from "@mui/material";
import MainCard from "../../components/Cards/MainCard";
import PositionHistoryList from "./PositionHistoryList";
import { CANDIDATURE } from "../../helpers/accessModule";
import { LIST_CANDIDATURES } from "../../helpers/accessSubmodule";
import { useNavigate } from "react-router-dom";
import { useStore } from "react-redux";

const Index = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const store = useStore();

    const { module, submodules } = store.getState().auth.access;

    useEffect(() => {
        if (!module.includes(CANDIDATURE)) {
            navigate("/403");
        }
    }, []);

    return (
        <Grid container rowSpacing={4.5} columnSpacing={2.75}>
            {submodules.includes(LIST_CANDIDATURES) && (
                <Grid item xs={12} md={12} lg={12}>
                    <MainCard title={t("historiquedescandidatures")}>
                        <PositionHistoryList />
                    </MainCard>
                </Grid>
            )}
        </Grid>
    );
};

export default Index;
